export default class heroSliderOverlaidtext {
    /*
     * Fires first
     */
    constructor() { 
        /*
        * Initialize slider
        */
         $('.js-hero-slider-overlaid-text').slick({
            autoplay: false,
            autoplaySpeed: 4500,
            arrows: true,
            dots: true, 
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            // nextArrow: '<button class="slick-slider__arrow-next w-4 h-8 z-10 absolute right-12 top-1/2 translate-y-1/2 focus:outline-none focus:outline-none bg-center bg-no-repeat bg-contain"></button>',
            // prevArrow: '<button class="slick-slider__arrow-prev w-4 h-8 z-10 absolute left-12 top-1/2 translate-y-1/2 focus:outline-none focus:outline-none bg-center bg-no-repeat bg-contain"></button>',
            responsive: [ 
                {
					breakpoint: 1025,
					settings: { 
                        dots: false, 
                        arrows: false,
					},
				},
			],
        });

    }
}